import React, { useEffect, useMemo, useState } from 'react';
import { TableWrapper } from '../TableWrapper';
import { ProductsFeedsTableHeader } from './ProductsFeedsTableHeader';
import { useSelector } from 'react-redux';
import { CymbioSpinner } from '../../common/Spinner';
import styles from './ProductsFeedsTable.module.scss';
import { ProductsFeedRowsRenderer } from './ProductsFeedRowsRenderer';
import { downloadAllDocument } from '../../../utils/exportHelper';

export function ProductsFeedsTable() {
  const { isLoading, data } = useSelector((state) => state.productsFeeds);
  const [selected, setSelected] = useState([]);
  const allSuccessBatchIds = useMemo(
    () => data.filter((row) => row.status === 'created').map((row) => row.batch_id),
    [data],
  );

  useEffect(() => {
    if (isLoading) {
      setSelected([]);
    }
  }, [isLoading]);

  const onChange = (checked, value) => {
    if (checked) {
      setSelected((prevSelected) => [...prevSelected, value]);
    } else {
      setSelected((prevSelected) => {
        const index = prevSelected.indexOf(value);
        const newSelected = [...prevSelected];
        newSelected.splice(index, 1);
        return newSelected;
      });
    }
  };

  const onChangeSelectAll = (checked) => {
    if (checked) {
      setSelected(allSuccessBatchIds);
    } else {
      setSelected([]);
    }
  };

  const downloadAllSelectedDocuments = () => {
    const urls = selected.map((batchId) => data.find((row) => row.batch_id === batchId)?.report_url);
    downloadAllDocument(urls);
  };

  return (
    <>
      <TableWrapper hasExpandedRow={false} className={styles.table}>
        <ProductsFeedsTableHeader
          hasData={data?.length > 0}
          onChangeSelectAll={onChangeSelectAll}
          allSelected={allSuccessBatchIds.length === selected.length}
        />

        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={8}>
                <CymbioSpinner />
              </td>
            </tr>
          ) : (
            <ProductsFeedRowsRenderer rows={data} selected={selected} onChange={onChange} />
          )}
        </tbody>
      </TableWrapper>
      {selected.length > 0 && (
        <button type="button" className={styles.button} onClick={downloadAllSelectedDocuments}>
          Download All Selected
        </button>
      )}
    </>
  );
}
